import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ContentCopySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ContentCopySVG;
